import React, { useEffect, useCallback } from 'react';

const CursorGlow = ({ children, className = '' }) => {
  const isTouchDevice = typeof window !== 'undefined' && 'ontouchstart' in window;

  const handleMouseMove = useCallback((e) => {
    document.documentElement.style.setProperty('--mouse-x', `${e.clientX}px`);
    document.documentElement.style.setProperty('--mouse-y', `${e.clientY}px`);
  }, []);

  useEffect(() => {
    if (isTouchDevice) return;

    window.addEventListener('mousemove', handleMouseMove, { passive: true });
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, [handleMouseMove, isTouchDevice]);

  if (isTouchDevice) {
    return <div className={className}>{children}</div>;
  }

  return (
    <div className={`cursor-glow ${className}`}>
      {children}
    </div>
  );
};

export default CursorGlow;
